import { keyframes, css } from 'styled-components';

// ===== ANIMAÇÕES DE ENTRADA AVANÇADAS =====

export const slideInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(60px) scale(0.95);
    filter: blur(4px);
  }
  50% {
    opacity: 0.7;
    transform: translateY(20px) scale(0.98);
    filter: blur(1px);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
`;

export const slideInDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-60px) scale(0.95);
    filter: blur(4px);
  }
  50% {
    opacity: 0.7;
    transform: translateY(-20px) scale(0.98);
    filter: blur(1px);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
`;

export const slideInLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-80px) scale(0.95);
    filter: blur(4px);
  }
  50% {
    opacity: 0.7;
    transform: translateX(-20px) scale(0.98);
    filter: blur(1px);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
    filter: blur(0);
  }
`;

export const slideInRight = keyframes`
  0% {
    opacity: 0;
    transform: translateX(80px) scale(0.95);
    filter: blur(4px);
  }
  50% {
    opacity: 0.7;
    transform: translateX(20px) scale(0.98);
    filter: blur(1px);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
    filter: blur(0);
  }
`;

export const scaleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8) rotate(-5deg);
    filter: blur(4px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) rotate(1deg);
    filter: blur(1px);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
    filter: blur(0);
  }
`;

export const rotateIn = keyframes`
  0% {
    opacity: 0;
    transform: rotate(-180deg) scale(0.5);
    filter: blur(8px);
  }
  50% {
    opacity: 0.6;
    transform: rotate(-90deg) scale(0.8);
    filter: blur(2px);
  }
  100% {
    opacity: 1;
    transform: rotate(0deg) scale(1);
    filter: blur(0);
  }
`;

// ===== ANIMAÇÕES DE SAÍDA =====

export const slideOutUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
  50% {
    opacity: 0.7;
    transform: translateY(-20px) scale(0.98);
    filter: blur(1px);
  }
  100% {
    opacity: 0;
    transform: translateY(-60px) scale(0.95);
    filter: blur(4px);
  }
`;

export const slideOutDown = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
  50% {
    opacity: 0.7;
    transform: translateY(20px) scale(0.98);
    filter: blur(1px);
  }
  100% {
    opacity: 0;
    transform: translateY(60px) scale(0.95);
    filter: blur(4px);
  }
`;

export const scaleOut = keyframes`
  0% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
    filter: blur(0);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) rotate(1deg);
    filter: blur(1px);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) rotate(-5deg);
    filter: blur(4px);
  }
`;

// ===== ANIMAÇÕES DE HOVER E MICRO-INTERAÇÕES =====

export const hoverLift = keyframes`
  0% {
    transform: translateY(0) scale(1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  100% {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }
`;

export const hoverGlow = keyframes`
  0% {
    box-shadow: 0 0 20px rgba(255, 68, 68, 0.3);
  }
  50% {
    box-shadow: 0 0 40px rgba(255, 68, 68, 0.6);
  }
  100% {
    box-shadow: 0 0 20px rgba(255, 68, 68, 0.3);
  }
`;

export const pulseGlow = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 20px rgba(255, 68, 68, 0);
  }
`;

export const shimmer = keyframes`
  0% {
    transform: translateX(-100%) skewX(-15deg);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(200%) skewX(-15deg);
    opacity: 0;
  }
`;

export const ripple = keyframes`
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
`;

// ===== ANIMAÇÕES DE FLUTUAÇÃO E MOVIMENTO =====

export const float = keyframes`
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-10px) rotate(1deg);
  }
  66% {
    transform: translateY(-5px) rotate(-1deg);
  }
`;

export const floatSlow = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
`;

export const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const orbit = keyframes`
  0% {
    transform: rotate(0deg) translateX(50px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(50px) rotate(-360deg);
  }
`;

// ===== ANIMAÇÕES DE TEXTO =====

export const typewriter = keyframes`
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
`;

export const blink = keyframes`
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
`;

export const textReveal = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
    filter: blur(4px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
`;

// ===== ANIMAÇÕES DE PARTÍCULAS =====

export const particleFloat = keyframes`
  0% {
    transform: translateY(0) rotate(0deg) scale(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
    transform: scale(1);
  }
  90% {
    opacity: 1;
    transform: translateY(-100px) rotate(180deg) scale(1);
  }
  100% {
    transform: translateY(-120px) rotate(360deg) scale(0);
    opacity: 0;
  }
`;

export const particleBurst = keyframes`
  0% {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.2) rotate(180deg);
    opacity: 0.8;
  }
  100% {
    transform: scale(0) rotate(360deg);
    opacity: 0;
  }
`;

// ===== ANIMAÇÕES DE LOADING =====

export const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const bounce = keyframes`
  0%, 20%, 53%, 80%, 100% {
    transform: translateY(0);
  }
  40%, 43% {
    transform: translateY(-30px);
  }
  70% {
    transform: translateY(-15px);
  }
  90% {
    transform: translateY(-4px);
  }
`;

export const wave = keyframes`
  0%, 100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.5);
  }
`;

// ===== ANIMAÇÕES DE MORPHING =====

export const morph = keyframes`
  0% {
    border-radius: 20px;
    transform: scale(1);
  }
  25% {
    border-radius: 50px;
    transform: scale(1.1);
  }
  50% {
    border-radius: 10px;
    transform: scale(0.9);
  }
  75% {
    border-radius: 30px;
    transform: scale(1.05);
  }
  100% {
    border-radius: 20px;
    transform: scale(1);
  }
`;

// ===== ANIMAÇÕES DE GLASSMORPHISM =====

export const glassShimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// ===== MIXINS DE ANIMAÇÃO =====

export const animationMixin = css`
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  will-change: transform, opacity, filter;
`;

export const smoothTransition = css`
  transition: all 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
`;

export const fastTransition = css`
  transition: all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
`;

export const slowTransition = css`
  transition: all 0.8s cubic-bezier(0.25, 0.1, 0.25, 1);
`;

// ===== EASING FUNCTIONS =====

export const easings = {
  easeInOut: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  easeOut: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  easeIn: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  elastic: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  smooth: 'cubic-bezier(0.4, 0, 0.2, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
};

// ===== UTILITÁRIOS =====

export const getStaggerDelay = (index: number, baseDelay: number = 100) => 
  `${index * baseDelay}ms`;

export const getRandomDelay = (min: number = 0, max: number = 1000) => 
  `${Math.random() * (max - min) + min}ms`;

export const getRandomDuration = (min: number = 500, max: number = 1500) => 
  `${Math.random() * (max - min) + min}ms`;
